<template lang="pug">
  form(@submit.prevent="onSubmit")
    .form-group
      label.control-label(for='name') {{ trans('labels.frontend.contact-us.send_message_name') }}
      input.form-control(type='text', :placeholder="trans('labels.frontend.contact-us.send_message_name')" id="name" name="name" v-model="form.name")
    .form-group
      label.control-label(for='email') {{ trans('labels.frontend.contact-us.send_message_email') }}
      input.form-control(type='email', :placeholder="trans('labels.frontend.contact-us.send_message_email')" id="email" name="email" v-model="form.email")
    .form-group
      label.control-label(for='message') {{ trans('labels.frontend.contact-us.send_message_details') }}
      textarea.form-control(:placeholder="trans('labels.frontend.contact-us.send_message_details')" id="message" name="message" v-model="form.message")
    button.btn.btn-primary.btn-block(type="submit" :disabled='$v.$invalid' v-if="!$wait.is('submitting contact form')") {{ trans('labels.frontend.contact-us.send_message_button') }}
    button.btn.btn-primary.btn-block(type="submit" :disabled='true' v-if="$wait.is('submitting contact form')")
      font-awesome-icon.mr-2(:icon="['far', 'circle-notch']" spin)
      | {{ trans('alerts.general.please_wait') }}
</template>

<script>

import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { RepositoryFactory } from '../../repositoryFactory';
import notify from '../../components/notify';

const PageRepository = RepositoryFactory.get('page');

export default {
  mixins: [validationMixin],
  data() {
    return {
      form: {
        name: '',
        email: '',
        message: '',
      },
    };
  },
  methods: {
    async onSubmit() {
      this.$wait.start('submitting contact form');
      try {
        await PageRepository.contact().submit(this.form);
        this.form = {
          name: '', email: '', message: '',
        };
        notify.success(this, { title: Lang.get('alerts.frontend.general.sent') });
      } catch (e) {
        notify.errors(this, e);
      }
      this.$wait.end('submitting contact form');
    },
  },
  validations: {
    form: {
      name: { required },
      email: { required, email },
      message: { required },
    },
  },
};
</script>
